import React, { useState } from 'react';
import { BILL_DETAILS_STYLES } from '../styles';
import { useStore } from '../../../../../../../store';
import BillPreviewHasAttachment from './BillPreviewHasAttachment';
import BillPreviewNoAttachment from './BillPreviewNoAttachment';
import { featureAccess, LimitedFeatureType } from '../../../../../../../services/appAccess.service';
import { FEATURE_FLAG } from '../../../../../../../constants/general';
import { FeatureAccess } from '../../../../../../AccountSettings/components/rolesAndPermissions/PermissionsList';

const BillsPreviewAttachment = () => {
  const selectedBill = useStore((state) => state.selectedBill);
  const [uploadDone, setUploadDone] = useState<boolean | null>(null);
  const [documentIdFromResponse, setDocumentIdFromResponse] = useState('');
  const billPayPermission = featureAccess(FEATURE_FLAG.BILL_PAY, LimitedFeatureType.BillPay);
  return (
    <div className={BILL_DETAILS_STYLES.ATTACHMENT.wrapper}>
      {selectedBill?.documentId || uploadDone ? (
        <BillPreviewHasAttachment documentIdFromResponse={documentIdFromResponse} />
      ) : (
        billPayPermission === FeatureAccess.READ_WRITE && (
          <BillPreviewNoAttachment
            setUploadDone={setUploadDone}
            setDocumentIdFromResponse={setDocumentIdFromResponse}
          />
        )
      )}
    </div>
  );
};

export default BillsPreviewAttachment;
